export default "__VITE_ASSET__0gWfMl6Q__"